/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';
import { useState, useEffect, useRef } from 'react';

const TabTextField2 = (props: any) => {
    const {index, data, definition, name, handleChange, disabled} = props;
    const [readonly, setReadOnly] = useState<boolean>(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const [localValue, setLocalValue] = useState(data[name] || "");

    // Update local value when data changes from parent
    useEffect(() => {
        setLocalValue(data[name] || "");
    }, [data, name]);

    const handlechange = (event: any) => {
        const value = event.target.value;
        setLocalValue(value); // Update local state immediately
        handleChange(name, value, data.id, index);
    }

    useEffect(() => {
        const objecttype = definition.filter((item: any) => item.name === 'objecttype')
        if (objecttype[0]?.attributes?.permission) {
            if (objecttype[0]?.attributes?.permission === 'readonly') {
                setReadOnly(true);
            } else {
                setReadOnly(false)
            }
        }
    }, [definition])

    return (
        <td key={index} style={{ padding: '0px 10px', overflow: 'hidden', height: 40 }}>
            <input
                ref={inputRef}
                className="form-control"
                onChange={handlechange}
                type="text"
                readOnly={readonly || disabled}
                style={{ width: '100%', padding: '3px', fontSize: '13px', fontWeight: 500, color: '#3F4254' }}
                name={name}
                value={localValue}
            />
        </td>
    )
}

export default TabTextField2;